import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import username from 'flarum/common/helpers/username';

/**
 * "Somebody liked your picture."
 */
export default class LikeNotification extends Notification {
  icon() {
    return 'fas fa-heart';
  }
  href() {
    const subject = this.attrs.notification.subject();
    return subject ? app.route('atrium.image', {
      id: subject.id()
    }) : app.route('atrium.index');
  }
  content() {
    return app.translator.trans('ernestdefoe-atrium.forum.notifications.like', {
      // 🚨 Never a placeholder named `user`. Flarum's translator singles that
      // one name out and calls displayName() on whatever it is given, so a
      // vnode throws and a deleted uploader throws — and the throw happens
      // inside an ItemList callback, which swallows everything after it.
      username: username(this.attrs.notification.fromUser())
    });
  }
  excerpt() {
    const subject = this.attrs.notification.subject();
    return subject?.title() || subject?.albumTitle() || null;
  }
}
flarum.reg.add('ernestdefoe-atrium', 'forum/components/LikeNotification', LikeNotification);